import { Link } from 'react-router-dom';

export default function ProductHeader() {
  return (
    <section className="relative bg-gradient-to-br from-emerald-50 via-white to-blue-50 py-12 sm:py-16 md:py-20 lg:py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-4xl mx-auto">
          {/* Breadcrumb */}
          <div className="flex items-center justify-center gap-2 mb-6 sm:mb-8">
            <Link to="/" className="text-sm text-gray-600 hover:text-emerald-700 transition-colors">
              Home
            </Link>
            <i className="ri-arrow-right-s-line text-base text-gray-400"></i>
            <span className="text-sm text-emerald-700 font-medium">Products</span>
          </div>

          {/* Title */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
            Premium Agricultural{' '}
            <span className="text-emerald-700">Products</span>
          </h1>

          {/* Description */}
          <p className="text-base sm:text-lg text-gray-600 mb-8 sm:mb-10 md:mb-12 leading-relaxed max-w-2xl mx-auto">
            Discover our extensive range of high-quality agricultural products, sourced from India's finest regions and certified for international export standards.
          </p>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-4 sm:gap-6 md:gap-8 max-w-3xl mx-auto">
            <div className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-5 md:p-6 shadow-md hover:shadow-lg transition-shadow">
              <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-emerald-700 mb-1 sm:mb-2">24+</div>
              <div className="text-xs sm:text-sm text-gray-600">Products</div>
            </div>
            <div className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-5 md:p-6 shadow-md hover:shadow-lg transition-shadow">
              <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-emerald-700 mb-1 sm:mb-2">6</div>
              <div className="text-xs sm:text-sm text-gray-600">Categories</div>
            </div>
            <div className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-5 md:p-6 shadow-md hover:shadow-lg transition-shadow">
              <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-emerald-700 mb-1 sm:mb-2">100%</div>
              <div className="text-xs sm:text-sm text-gray-600">Quality</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
